// extracted by mini-css-extract-plugin
module.exports = {"room":"SingleShowroomCard_room__15Gjj","room_type":"SingleShowroomCard_room_type__25Ace","room_note":"SingleShowroomCard_room_note__1nYIw"};